import { useState, useEffect } from "react";
import SummaryClasses from "./Summary.module.css";
import { Tax_Summary } from "Services/Requests";
import Loader from "Components/Loader/loader";
import { showWarningAlert } from "Utils/Alerts";
import { useForm, SubmitHandler } from "react-hook-form";
import { useStore } from "Store";

interface Inputs {
    federal_payment: any;
    federal_value: any;
    itin_value: any;
    itin_payment: any;
    business_filing_value: any;
    business_filing_payment: any;
    election_value: any;
    election_payment: any;
    fbar_payment: any;
    fbar_value: any;
    fatca_value: any;
    fatca_payment: any;
    additional_fee_value: any;
    additional_fee_payment: any;
    other_fee_payment: any;
    other_fee_value: any;
    discount_price: any;
    discount_type: any;
    total: any;
    total_after_discount: any;
}
function TaxSummary() {
    const { isDisabled } = useStore((state: any) => state);

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        control,
        reset,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            federal_payment: 0,
            federal_value: 0,
            itin_value: 0,
            itin_payment: 0,
            business_filing_value: 0,
            business_filing_payment: 0,
            election_value: 0,
            election_payment: 0,
            fbar_payment: 0,
            fbar_value: 0,
            fatca_value: 0,
            fatca_payment: 0,
            additional_fee_value: 0,
            additional_fee_payment: 0,
            other_fee_payment: 0,
            other_fee_value: 0,
            discount_price: 0,
            total: 0,
            total_after_discount: 0,
            discount_type: "$",
        },
    });
    const [loading, setLoading] = useState(true);
    const [summary, setSummary] = useState([]);
    const formData = watch();
    const GetDetails = async () => {
        setLoading(true);
        try {
            const response = await Tax_Summary();

            setLoading(false);
            if (response.data.Status == 1) {
                reset(response?.data?.taxsummary);
            } else {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team1"
                );
                setLoading(false);
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        GetDetails();
    }, []);

    return (
        <div className={SummaryClasses["Container"]}>
            <form className={SummaryClasses["info"]}>
                <h3>Tax Summary</h3>
                <table>
                    <thead>
                        <th>For</th>
                        <th>Refund/Due</th>
                        <th>Payment</th>
                    </thead>
                    <tbody>
                        {formData?.federal_payment > 0 && (
                            <tr>
                                <td>FEDERAL</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("federal_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("federal_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}

                        {formData?.itin_payment > 0 && (
                            <tr>
                                <td>ITIN</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("itin_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("itin_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.business_filing_payment > 0 && (
                            <tr>
                                <td>BUSINESS FILING</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("business_filing_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("business_filing_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.election_payment > 0 && (
                            <tr>
                                <td>ELECTION</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("election_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("election_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.fbar_payment > 0 && (
                            <tr>
                                <td>FBAR</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("fbar_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("fbar_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.fatca_payment > 0 && (
                            <tr>
                                <td>FACTA</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("fatca_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("fatca_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.additional_fee_payment > 0 && (
                            <tr>
                                <td>ADDITIONAL FEE</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("additional_fee_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("additional_fee_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.other_fee_payment > 0 && (
                            <tr>
                                <td>OTHER FEE</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("other_fee_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("other_fee_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td>TOTAL </td>
                            <td></td>
                            <td>
                                <input disabled {...register("total")} />
                            </td>
                        </tr>
                        <tr>
                            <td>DISCOUNT</td>
                            <td></td>
                            <td>
                                <input
                                    disabled
                                    type="text"
                                    {...register("discount_price")}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td>TOTAL AFTER DISCOUNT</td>
                            <td colSpan={2}>
                                <input
                                    disabled
                                    {...register("total_after_discount")}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button disabled={isDisabled}>Make Payment</button>
            </form>
        </div>
    );
}

export default TaxSummary;
